import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_AMAZON_API}/ShiXunGuanLi/GetCurrentUserTrainings`,
    method: 'get'
  })
}

export default {
  getCurrentUserTrainings
}
